<template>
  <v-container class="d-flex align-center justify-center pa-5" fluid>
    <v-row>
      <v-card class="py-10 px-7" outlined style="background-color: rgba(0,0,0,0); width: 100%">
        <v-form v-model="valid">
          <h1 class="text-center">{{ $t('title') }}</h1>
          <p class="text-center mb-7 mt-2">{{ $t('subtitle') }}</p>
          <v-text-field v-model="firstName" :label="$t('labels.firstName')"
                        :placeholder="$t('placeholders.firstName')" :rules="firstNameRule" outlined/>
          <v-text-field v-model="email" :label="$t('labels.email')" :placeholder="$t('placeholders.email')"
                        :rules="emailRule" outlined/>
          <v-text-field v-model="username" :label="$t('labels.username')" :placeholder="$t('placeholders.username')"
                        :rules="usernameRule" outlined/>
          <v-text-field v-model="password" :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                        :label="$t('labels.password')"
                        :placeholder="$t('placeholders.password')" :rules="passwordRule"
                        :type="showPassword ? 'text' : 'password'"
                        outlined @click:append="showPassword = !showPassword"/>
          <v-btn :disabled="!valid" class="swiset-button" width="100%" @click="submitRegister">
            {{ $t('btnRegister') }}
          </v-btn>
        </v-form>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import Repository from '../repositories/auth';
import { mapMutations } from 'vuex';

export default {
  name: "CollapsedRegister",
  props: {
    campaign: String,
  },
  data() {
    return {
      landingKey: '',
      highlight: '',

      firstName: '',
      email: '',
      username: '',
      password: '',

      // Rules
      showPassword: false,
      valid: false,
      firstNameRule: [
        p => !!p || 'First Name is required',
      ],
      emailRule: [
        e => !!e || 'Email is required',
        e => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e) || 'Invalid email',
      ],
      usernameRule: [
        u => !!u || 'Username is required',
        u => (u || '').length < 35 || 'Username should have less than 35 characters.',
        u => !u.includes('@') || 'Not \'@\' allowed',
        u => !u.includes('&')  || 'Not & allowed',
        u => (u.split(' ').length <= 1) || 'Not spaces allowed',
      ],
      passwordRule: [
        p => !!p || 'Password is required',
        p => (p || '').length < 60 || 'Password should have less than 60 characters.',
        p => (p || '').length > 6 || 'Password should have at least 7 characters.',
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if(this.$route.query.landingKey !== undefined)
        this.landingKey = this.$route.query.landingKey;
      if(this.$route.query.highlight !== undefined)
        this.highlight = this.$route.query.highlight;
    },
    ...mapMutations(['setCurrentUser']),
    submitRegister() {
      if (this.valid) {
        let user = {
          firstName: this.firstName,
          lastName: 'NOT REGISTERED',
          email: this.email,
          username: this.username,
          password: this.password,
          phoneNumber: 'NOT REGISTERED',
        };
        Repository.existingUsernameOrEmail(this.username, this.email).then((response) => {
          if(response.status < 400 && response.data === -1) {
            Repository.registerCollapsedUser(user).then((secondResponse) => {
              if (secondResponse.status < 400) {
                window.fbq('track', 'SubmitApplication');
                window.fbq('trackCustom', 'VirtualPageView',
                    { url: (this.landingKey !== '')? `/pre-registration-by-mobile-${this.landingKey}` : '/pre-registration-by-mobile' });
                this.setCurrentUser(secondResponse.data);
                window.sendinblue.identify(this.email, {
                  'NOMBRE': this.firstName,
                  'SURNAME' : 'NOT REGISTERED',
                  'USERNAME': this.username,
                  'PHONE': 'NOT REGISTERED',
                  'COUNTRY': 'NOT REGISTERED',
                  'PRO_ON' : '0',
                  'LANG': this.$i18n.locale,
                  'USAGE_STATE': 'PRE_REGISTERED',
                  'COMMERCIAL_STATE': 'NEVER_PRO',
                });
                alert(this.$t('successfullyCreatedAccount'));
                if(this.highlight === undefined || this.highlight === '')
                  this.$router.push('/open-on-desktop');
                else
                  this.$router.push('/plans');
              }
            });
          }
          else
            alert(this.$t('alreadyUserMessage'));
        });
      }
    },
  }
}
</script>


<i18n>
{
  "en":{
    "title": "Join Now!",
    "subtitle": "Join thousands of smart traders in 100+ countries.",
    "labels": {
      "firstName": "Your name",
      "email": "Your email",
      "username": "Add a username",
      "password": "Set a password"
    },
    "placeholders": {
      "firstName": "e.g. John",
      "email": "e.g. john@gmail.com",
      "username": "e.g. johntrader",
      "password": "Write a password"
    },
    "successfullyCreatedAccount": "You account was successfully created!\nPlease verify your email (See your Inbox).",
    "alreadyUserMessage": "Username or email exists.\nPlease change data or reset your Swiset password.",
    "btnRegister": "Submit your register"
  },
  "es":{
    "title": "¡Únete Ahora!",
    "subtitle": "Únete a la comunidad confiada por miles de traders inteligentes en 100+ países.",
    "labels": {
      "firstName": "Dinos tu nombre",
      "email": "Escribe tu email",
      "username": "Agrega un username",
      "password": "Crea una contraseña"
    },
    "placeholders": {
      "firstName": "Ej. Pedro",
      "email": "Ej. pedro@gmail.com",
      "username": "Ej. pedrotrader",
      "password": "Escribe una contraseña"
    },
    "successfullyCreatedAccount": "¡Tú cuenta fue satisfactoriamente creada!\nPor favor verifica tu email (Mira tú bandeja de entrada).",
    "alreadyUserMessage": "Username o email existen.\nPor favor cambia los datos o reinicia tu contraseña de Swiset.",
    "btnRegister": "Regístrate ya"
  }
}
</i18n>

<style scoped>

</style>
